import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { WishlistProvider } from "./contexts/WishlistContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Auth from "./pages/Auth";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderHistory from "./pages/OrderHistory";
import OrderDetail from "./pages/OrderDetail";
import WishlistPage from "./pages/Wishlist";
import AdminReviews from "./pages/admin/Reviews";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminProducts from "./pages/admin/Products";
import AdminCoupons from "./pages/admin/Coupons";
import AdminSales from "./pages/admin/Sales";
import AdminOrders from "./pages/admin/Orders";
import AdminPageBuilder from "./pages/admin/PageBuilder";
import AdminCollections from "./pages/admin/Collections";
import AdminCategories from "./pages/admin/Categories";
import AdminOrderDetail from "./pages/admin/OrderDetail";
import AdminPackingSlip from "./pages/admin/PackingSlip";
import AdminCustomers from "./pages/admin/Customers";
import AdminCustomerDetail from "./pages/admin/CustomerDetail";
import AdminSettings from "./pages/admin/Settings";
import AdminPromotions from "./pages/admin/Promotions";
import AdminBundles from "./pages/admin/Bundles";
import AdminFeatured from "./pages/admin/Featured";
import SalePage from "./pages/Sale";
import DynamicPage from "./pages/DynamicPage";
import Footer from "./components/Footer";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// The printable packing slip has no site chrome
function SiteFooter() {
  const { pathname } = useLocation();
  return pathname.endsWith("/packing-slip") ? null : <Footer />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <WishlistProvider>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/products/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
                <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
                <Route path="/orders" element={<ProtectedRoute><OrderHistory /></ProtectedRoute>} />
                <Route path="/orders/:id" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/sale" element={<SalePage />} />
                <Route path="/pages/:slug" element={<DynamicPage />} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
                <Route path="/admin/products" element={<ProtectedRoute adminOnly><AdminProducts /></ProtectedRoute>} />
                <Route path="/admin/collections" element={<ProtectedRoute adminOnly><AdminCollections /></ProtectedRoute>} />
                <Route path="/admin/coupons" element={<ProtectedRoute adminOnly><AdminCoupons /></ProtectedRoute>} />
                <Route path="/admin/sales" element={<ProtectedRoute adminOnly><AdminSales /></ProtectedRoute>} />
                <Route path="/admin/orders" element={<ProtectedRoute adminOnly><AdminOrders /></ProtectedRoute>} />
                <Route path="/admin/orders/:id" element={<ProtectedRoute adminOnly><AdminOrderDetail /></ProtectedRoute>} />
                <Route path="/admin/orders/:id/packing-slip" element={<ProtectedRoute adminOnly><AdminPackingSlip /></ProtectedRoute>} />
                <Route path="/admin/categories" element={<ProtectedRoute adminOnly><AdminCategories /></ProtectedRoute>} />
                <Route path="/admin/customers" element={<ProtectedRoute adminOnly><AdminCustomers /></ProtectedRoute>} />
                <Route path="/admin/customers/:id" element={<ProtectedRoute adminOnly><AdminCustomerDetail /></ProtectedRoute>} />
                <Route path="/admin/settings" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
                <Route path="/admin/promotions" element={<ProtectedRoute adminOnly><AdminPromotions /></ProtectedRoute>} />
                <Route path="/admin/bundles" element={<ProtectedRoute adminOnly><AdminBundles /></ProtectedRoute>} />
                <Route path="/admin/featured" element={<ProtectedRoute adminOnly><AdminFeatured /></ProtectedRoute>} />
                <Route path="/admin/page-builder" element={<ProtectedRoute adminOnly><AdminPageBuilder /></ProtectedRoute>} />
                <Route path="/admin/reviews" element={<ProtectedRoute adminOnly><AdminReviews /></ProtectedRoute>} />
              </Routes>
              <SiteFooter />
            </WishlistProvider>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
